<div class="hero-content">
  <div class="hero-title">
    <h1 class="hero-title__heading">
      <span>{{ 'home.hero.hero-heading' | translate }}</span>
      <span class="hero-title__heading-bold">{{ 'home.hero.hero-heading-bold' | translate }}</span>
    </h1>
  </div>
  <div class="hero-segments">
    <h2 class="heading-s">{{ 'home.hero.segments-heading' | translate }}</h2>
    <div class="hero-segments__bloc">
      <p class="body-m">{{ 'home.hero.segments-bloc-title' | translate }}</p>
      <div class="hero-segments__content">
        @for (segment of captureNeedService.needCapture.productUse.segments(); track segment) {
          <app-card
            [text]="segment.name"
            [icon]="segment.icon"
            [state]="segment === captureNeedService.needCapture.productUse.selectedSegment() ? 'selected' : 'default'"
            (cardClicked)="handleSelectedSegment(segment)"></app-card>
        }
        @for (segment of segmentStatic; track segment) {
          <app-card
            [text]="segment.name"
            [icon]="segment.icon"
            [state]="segment === captureNeedService.needCapture.productUse.selectedSegment() ? 'selected' : 'default'"
            (cardClicked)="handleSelectedSegment(segment)"></app-card>
        }
      </div>
    </div>
    <app-button
      class="hero-segments__button"
      routerLink="/protected/capture-needs"
      size="large"
      icon="call_made"
      text="{{ 'home.hero.start-creating' | translate }}"></app-button>
    <div class="img-container">
      @if (isVisible) {
        <img
          [src]="'/assets/images/segments/' + getSegmentName(captureNeedService.needCapture.productUse.selectedSegment()) + '.webp'"
          [appImgFallback]="'/assets/images/segments/' + getSegmentName(captureNeedService.needCapture.productUse.selectedSegment()) + '.png'"
          [alt]="getSegmentName(captureNeedService.needCapture.productUse.selectedSegment())"
          [class.hero-segments__image--visible]="true"
          [@imageFade]
          loading="lazy"
          class="hero-segments__image" />
      }
    </div>
  </div>
</div>
